import { SelectionTexto } from "./SelectionTexto";

export class LeitorToolbarParameters {
  selection: SelectionTexto;
}
